export default __webpack_public_path__ + "static/media/splitIcon.b9818b18.svg";